// Section 17: priority group 'Children under 6'. Members are listed in sorted id order; the rationing
// phase ranks groups by the policy's order and breaks ties by lowest strength first.
import { definePriorityGroup } from '../../core/registry';
import { peopleSorted } from '../../core/queries';
import type { Config } from '../../config';

export function childrenUnder6(_config: Config) {
  return definePriorityGroup({
    id: 'children-under-6',
    label: 'Children under 6',
    section: 'S17',
    members: (ctx) =>
      peopleSorted(ctx.state)
        .filter(
          (p) =>
            p.ageSeasons < ctx.cfg.rationing.youngChildUnderYears * ctx.cfg.people.seasonsPerYear,
        )
        .map((p) => p.id),
  });
}
